import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ReadTextForm from '../forms/read-text-form';
import { textReadValidationSchema } from '../schema/text.js';

export default function ReadTextNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Read Text Node Details',
        altText: 'Read Text Node',
        defaultLabel: 'Read Text Node',
      }}
    >
      <CommonNode FormComponent={ReadTextForm} schemaResolver={textReadValidationSchema} />
    </NodeProvider>
  );
}
